

module user {
  'use strict';

  export class SubscribeNewsletterCtrl implements ng.IController  {


    // $inject annotation.
    // It provides $injector with information about dependencies to be injected into constructor
    // it is better to have it close to the constructor, because the parameters must match in count and type.
    // See http://docs.angularjs.org/guide/di
    public static $inject = [
      '$scope',
      'userService',
      '$timeout',
      '$q',
      '$mdDialog',
      'debounce',
      'partnerService',
      '$analytics',
    ];

    // dependencies are injected via AngularJS $injector
    // controller's name is registered in Application.ts and specified from ng-controller attribute in index.html
    constructor(
      private $scope: ISubscribeNewsletterController,
      private userService: user.UserService,
      private $timeout: ng.ITimeoutService,
      private $q: ng.IQService,
      private $mdDialog: ng.material.IDialogService,
      private debounce: navigation.IDebounceService,
      private partnerService : partner.PartnerService,
      private $analytics: angulartics.IAnalyticsService
    ) {

      $scope.vm = this; 
      $scope.success = false;      
      $scope.request = <RegisterData>{};
      $scope.step = -1;

      
      $scope.request.Language = {
          "D": "1",
          "E": "2"
        }[pglob.RouteData.CurrentLanguage.hl];

    }

    locals : { 
      parentScope: ISubscribeNewsletterController,
      verteilerid: string 
    };
    
    public $onInit(): void {
      //check if email already in system
      if (this.locals && this.locals.parentScope) {
        this.$scope.requestOnGoing = true;
        this.userService.checkNsEMail(this.locals.parentScope.subscriberEmail, this.locals.verteilerid)
        .then((response) => { 
          this.$scope.request.Email = this.locals.parentScope.subscriberEmail;
          this.$scope.request.VerteilerId = this.locals.verteilerid;
          if (response.data) {
            this.$scope.step = response.data;            
          } else {
            this.$scope.step = 0;            
          } 
        })
        .catch((response) => {
          this.$scope.error = true;
        })
        .finally(() => {
          this.$scope.requestOnGoing = false;
        });
      } 
    }




    private saveProfile(nextStep : number) {
      this.$scope.requestOnGoing = true;
      this.userService.upsertNewsletterProfile(this.$scope.request)
      .then((response) => { 
        this.$scope.request = response.data; 
        this.$scope.step = nextStep;
      })
      .catch((response) => {
        this.$scope.error = true;
      })
      .finally(() => {
        this.$scope.requestOnGoing = false;
      });
    }
    
    closeDialog() {
      this.$mdDialog.hide();
    }

    cancelDialog() {
      this.$mdDialog.cancel();
    };

    OpenSubscribeEMailPopUp(ev :  MouseEvent, email: string, verteilerid: string) {
      if (this.$scope.subscribeEMailForm.$invalid) return; 

      this.$mdDialog.show(<ng.material.IDialogOptions>{
        controller: 'SubscribeNewsletterCtrl',
        templateUrl: 'user/SubscribeNewsletterCtrl',
        parent: angular.element(document.body),
        bindToController: true,
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: true, // Only for -xs, -sm breakpoints.
        locals: {
          parentScope: this.$scope,
          verteilerid: verteilerid
        },
      })
        .then(() => {
          //console.log('Modal closed at: ' + new Date());
          this.$scope.subscriberEmail = null;
          this.$scope.subscribeEMailForm.$setUntouched();
        }, () => {
          //console.log('Modal canceled at: ' + new Date());
          this.$scope.subscriberEmail = null;
          this.$scope.subscribeEMailForm.$setUntouched();
        });
    }

    loadCountries() : ng.IPromise<any> {
      return this.$timeout(() : ng.IPromise<any> => {
        if (this.$scope.countries) return this.$q.when('already loaded');
          
          this.$scope.requestOnGoing = true;
        return this.partnerService.getPartnerData().then((data: partner.VendorResult) => {
          this.$scope.countries = data.Countries;
          var currentCountry = data.Countries.filter(function(val:partner.Country, index: number) :boolean {
            return val.Code == data.LocationCountryCode;
          });
          this.$scope.request.Country = currentCountry[0]; //country of the visitor or null if not found
          this.$scope.requestOnGoing = false;
        });
      }, 200);
    }

    
    save(step : number) {      
      this.$scope.subscribeNewsletterForm.$setDirty();
      if (this.$scope.subscribeNewsletterForm.$invalid) return; 
      this.saveProfile(step);      
      this.$analytics.eventTrack('NewsletterSubscribeUpdate', {  category: 'User' });
    };

  }
};
